import Base from "@/api/Base";
import * as Log from "@/helper/Log";

export default class Exclusion extends Base
{
	setJobProfileId (v)
	{
		this.jobProfileId = v;
		return this;
	}

	setType (v)
	{
		this.data.type = v;
		return this;
	}

	setJob (v)
	{
		this.data.job = v;
		return this;
	}

	add ()
	{
		this.method = 'POST';
		return this;
	}

	remove ()
	{
		this.method = 'DELETE';
		return this;
	}

	getMethod ()
	{
		if (!this.method)
		{
			Log.error('Calling add() or remove() is mandatory');
		}

		return this.method;
	}

	getUrl ()
	{
		return '/kandidat/stellenprofil/' + this.jobProfileId + '/ausschluss';
	}
}
